export enum GrainUsageTypeEnum {
  SEED = 'SEED',
  GOODS = 'GOODS',
}

export enum GrainStorageTypeEnum {
  FUTURES = 'FUTURES',
  FORWARD = 'FORWARD',
  EXTRA_FUTURES = 'EXTRA_FUTURES',
  STORAGE = 'STORAGE',
  SPOT = 'SPOT',
  STATE_RESERVE = 'STATE_RESERVE',
  SEED = 'SEED',
}
